import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=c3e1ba40&"
import script from "./ChartBar.ts?vue&type=script&lang=ts&"
export * from "./ChartBar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports